import React, { useEffect, useState ,useRef} from 'react';
import './RVMStatus.css'
import FullscreenLoader from '../FullscreenLoader';
  import { showToast } from '../toastUtils';
import html2pdf from 'html2pdf.js';
import { queuedApiFetch, apiFetch } from '../api';
import * as XLSX from 'xlsx';

let globalRvwData = [];

function RVMStatus() {

  const contentRef = useRef();

  const [rvwData, setRvwData] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);
  //  const [selectedColumns, setSelectedColumns] = useState(columnOptions);
  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails): '';
  const userId = userDetails ? userDetails.id : '';
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = JSON.parse(getProjectDetails);
  const projectName = selectedProjectDetail.projectName;
  const defaultProjectNumber = selectedProjectDetail.projectNumber;
  const [loading, setLoading] = useState(true);
  const getUserEmail = localStorage.getItem('userEmail');

  let user_company = JSON.parse(localStorage.getItem("userCompany"));
  let nus_sts = (user_company === "NUS") ? 1 : 0;
  let p_access = selectedProjectDetail?.Proj_Access?.proj_access_level;
  let p_roles = selectedProjectDetail?.Proj_Access?.proj_role.join(", ");
  let proj_name=selectedProjectDetail?.projectName;

  let qs_params = `nususer=${nus_sts}&project_admin=${(p_access) ? 1 : 0}&project_roles=${encodeURIComponent(p_roles)}&project_name=${proj_name}`;


  useEffect(() => {
    fetchData();
    //fetchAPIData();
  }, []);

  const fetchData = async () => {
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
     try {
      const response = await queuedApiFetch(`/construction/get_rvws_status?project_id=${defaultProjectNumber}&user_id=${userId}&email_id=${getUserEmail}`, requestOptions);
      const data = await response;
  
      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {      
         globalRvwData = data.data;
         setRvwData(data.data);  
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); 
    }

  };

    const fetchAPIData = async () => {
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
     try {
      const response = await queuedApiFetch(`/construction/get_api_rvws_status?project_id=${defaultProjectNumber}&user_id=${userId}&email_id=${getUserEmail}`, requestOptions);
      const data = await response;
  
      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {      
         globalRvwData = data.data;
         setRvwData(data.data);  
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); 
    }

  };

const labelMapping = {
  rvw_no: 'RVW NO',
  rvw_type: 'Type of RVW',
  submitted_by: 'Submitted By', 
  // rvw_link: 'RVW Link',
  description: 'Description',
  work_description: 'Work Description',
  reason: 'Reason for RVW',
  nett_add: 'Nett Add/(Omit)',
  total_committed_amount: 'Total committed',
  balance_of_contingency: 'Balance of Contingency',
  time_implication: 'Time Implication (days)',
  
  status: 'Submission Status',
  review_status: 'Review Status',
  // aip_status: 'Approval in Principle Status',
  soi_no: 'SOI Number',
  issuance_date: 'Date of Issuance',
  supersede_no: 'Supersede/Close', 
  // review_link: 'Review Link'
  star_rate_items: 'Star Rate Items',
  star_rate_status: 'Star Rate Status'
};

const handleEditField = (index, field, value) => {
    const updatedRows = [...rvwData];
    updatedRows[index][field] = value;
    setRvwData(updatedRows);
  };

   const updateRVWStatusProject = async () => {
      // Avoid submitting if already in progress
      if (submitLoading) return;
  
      setSubmitLoading(true);
  
      const sendData = rvwData;
      const requestOptions = {
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        //   'ngrok-skip-browser-warning': '69420',
        // },
        body: JSON.stringify(sendData),
      };
  
      try {
        const response = await queuedApiFetch(`/construction/update_rvwstatus_project`,
          requestOptions
        );
        const result = await response;
  
        // Check if the response status is successful
        if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
          showToast.success('Data updated successfully..');
        } else {
          showToast.error(result.apistatus.Status_Description || 'Error occurred. Please try again.');
        }
      } catch (error) {
        console.error('Error saving data:', error);
        showToast.error('Something went wrong. Please try again.');
      } finally {
        setSubmitLoading(false); // Ensure loading state is reset after completion
      }
    };

  const handleDownloadPDF = () => {
        const element = contentRef.current;
    
        // Clone element and set wider width for full scroll capture
        const cloned = element.cloneNode(true);
        cloned.style.width = element.scrollWidth + "px";
          cloned.style.height = element.scrollHeight + "px";
    
          // Invisible container to render content without affecting layout
      const container = document.createElement("div");
      container.style.position = "absolute";
      container.style.left = "-9999px";
      container.style.top = "0";
      container.appendChild(cloned);
      document.body.appendChild(container);
    
        const opt = {
          margin: 0,
          filename: "RVWSStatus-Project.pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale: 1,
            scrollX: 0,
            scrollY: 0,
            width: element.scrollWidth, // capture full scroll width
            windowWidth: element.scrollWidth,
            height: element.scrollHeight, // capture full scroll height
            windowHeight: element.scrollHeight,
          },
          jsPDF: {
            unit: "px",
            format: [element.scrollWidth, element.scrollHeight, element.offsetHeight],
            orientation: element.scrollWidth > element.scrollHeight ? "landscape" : "portrait",
            //orientation: "landscape",
          },
        };
    
        html2pdf().set(opt).from(cloned).save()
        .then(() => {
          // Clean up
          document.body.removeChild(container);
        });
      };

  const handleDownloadCSV = () => {

    const keys = Object.keys(labelMapping);
    // const csvRows = [
    //   keys.map(key => labelMapping[key]), // header row
    //   ...rvwData.map(row => keys.map(key => row[key] ?? '')) // data rows
    // ];

    const csvRows = [
      keys.map(key => `"${labelMapping[key]}"`), // Header row with labels
      ...rvwData.map(row => keys.map(key => escapeCSVValue(row[key]))) // Data rows with sanitization
    ];

    const csvContent = csvRows.map(e => e.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'RVWSStatus-Project.csv';
    link.click();

    URL.revokeObjectURL(url); // clean up
  };

  const escapeCSVValue = (value) => {
    if (value == null) return '';

    let str = String(value).trim();

    // Normalize all unicode to block obfuscation (e.g., curly quotes → straight quotes)
    str = str.normalize('NFKC');

    // Escape double quotes (RFC-compliant)
    str = str.replace(/"/g, '""');

    // Protect against formula injection
    if (/^[=+\-@]/.test(str)) {
      // Completely neutralize potential formula, don’t just prefix with `'`
      // Option 1: prefix space (safe and minimal disruption)
      str = ` ${str}`;
    }

    // Extra protection: remove known dangerous formula fragments (if any remain)
    const lowerStr = str.toLowerCase();
    const dangerousKeywords = ['cmd|', '/c', 'powershell', 'shell', 'cmd.exe', 'notepad', 'calc'];
    for (const keyword of dangerousKeywords) {
      if (lowerStr.includes(keyword)) {
        // Completely strip the content or replace it
        //str = '[removed for safety]';
        str = '';
        break;
      }
    }

    return `"${str}"`;
  };

  const handleDownloadXLSX = () => {
      const keys = Object.keys(labelMapping);
      //const keys = selectedColumns;
      // Build worksheet data
      const worksheetData = [
        keys.map(key => labelMapping[key]), // Header row with mapped labels
        ...rvwData.map(row => keys.map(key => sanitizeXLSXValue(row[key]))) // Data rows with sanitization
      ];
      
      // Create worksheet & workbook
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "RVWSStatus-Project");
  
      // Export to file
      XLSX.writeFile(workbook, "RVWSStatus-Project.xlsx");
    };
  
  
    // Sanitize cell values for safety & consistency
    const sanitizeXLSXValue = (value) => {
      if (value == null) return '';
  
      let str = String(value).trim();
      str = str.normalize('NFKC'); // normalize unicode
  
      // Neutralize potential formula injection
      if (/^[=+\-@]/.test(str)) {
        str = ` ${str}`; // prefix with safe space
      }
  
      // Extra protection against dangerous keywords
      const lowerStr = str.toLowerCase();
      const dangerousKeywords = ['cmd|', '/c', 'powershell', 'shell', 'cmd.exe', 'notepad', 'calc'];
      for (const keyword of dangerousKeywords) {
        if (lowerStr.includes(keyword)) {
          str = '';
          break;
        }
      }
  
      return str;
    };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
  };

  return (
    <div className="bodywrap  proj_rvws_status_report">
      {loading && <FullscreenLoader />} 
      <div className="header" style={{ width: '100%' }}>
        <div className="projectwrap">
          <div className="addwbswrap" style={{background: '#e7e6e6'}}>
            <button disabled={rvwData && rvwData.length == 0 ? true : false} onClick={handleDownloadXLSX}>Export Excel</button>
            <button style={{marginLeft: '30px'}} disabled={rvwData && rvwData.length == 0 ? true : false} onClick={handleDownloadPDF}>Export PDF</button>
          </div>
          {/* <button id="submit" disabled={submitLoading || rvwData.length == 0 ? true : false} onClick={updateRVWStatusProject}>Submit</button> */}
        </div>
      </div>
      <div  className="tablewrap1">
        <div ref={contentRef} id="custom-tables" className="tablewrap">
          <table id="rvw_al_table" border="0" cellPadding="0" cellSpacing="0" style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                {/* <th className="xl6918834">RVW NO</th> */}
                <th className="xl6918834">S/N</th>
                <th className="xl6918834">Type of RVW</th>
                <th className="xl6918834">Submitted&nbsp;By</th>
                
                {/* <th className="xl6918834">RVW Link</th> */}
                <th className="xl6918834">Description</th>
                <th className="xl6918834">Work Description</th>
                <th className="xl6918834">Reason&nbsp;for RVW</th>
                <th className="xl6918834">Nett Add/(Omit)</th>
                <th className="xl6918834">Total committed</th>
                <th className="xl6918834">Balance of Contingency</th>
                <th className="xl6918834">Time Implication (days)</th>
                
                <th className="xl6918834">Submission Status</th>
                {/* <th className="xl6918834">Approval in Principle Status</th> */}
                <th className="xl6918834">Review Status</th>
                <th className="xl6918834">SOI Number</th>
                <th className="xl6918834">Date of Issuance</th>
                <th className="xl6918834">Supersede/Close</th>
                <th className="xl6918834">Star&nbsp;Rate Items</th>
                <th className="xl6918834">Star&nbsp;Rate Status</th>
                {/* <th className="xl6918834">Review Link</th> */}
{/* {selectedColumns.includes('rvw_no') && <th>RVW NO</th>}
{selectedColumns.includes('submitted_by') && <th>Submitted By</th>}
{selectedColumns.includes('rvw_type') && <th>Type of RVW</th>}
{selectedColumns.includes('rvw_link') && <th>RVW Link</th>}
{selectedColumns.includes('description') && <th>Description</th>}
{selectedColumns.includes('work_description') && <th>Work Description</th>}
{selectedColumns.includes('reason') && <th>Reason for RVW</th>}
{selectedColumns.includes('nett_add') && <th>Nett Add/(Omit)</th>}
{selectedColumns.includes('balance_of_contingency') && <th>Balance of Contingency</th>}
{selectedColumns.includes('star_rate_items') && <th>Star Rate Items</th>}
{selectedColumns.includes('star_rate_status') && <th>Star Rate Status</th>}
{selectedColumns.includes('status') && <th>Status</th>}
{selectedColumns.includes('aip_status') && <th>Approval in Principle Status</th>}
{selectedColumns.includes('soi_no') && <th>SOI Number</th>}
{selectedColumns.includes('issuance_date') && <th>Date of Issuance</th>}
{selectedColumns.includes('supersede_no') && <th>Supersede No</th>}
{selectedColumns.includes('review_status') && <th>Review Status</th>} */}
              </tr>
            </thead>
            <tbody>
            {rvwData.length > 0 ? (
                rvwData.map((item, index) => (
                  <tr key={item.id}>
                    <td className="xl7018834">{item.rvw_no}</td>
                    <td className="xl7018834">{item.rvw_type}</td>
                    <td className="xl7018834">{item.submitted_by}</td>
                    
                    {/* <td className="xl7018834">
                      <a target="_blank" href={item.rvw_link}>{item.rvw_link}</a>
                    </td> */}
                    {/* <td className="xl7018834">{item.description}</td> */}
                    <td className="xl7018834">{item.rvw_type+' '+item.rvw_no}</td>
                    <td className="xl7018834">{item.work_description}</td>
                    <td className="xl7018834">{item.reason}</td>
                    {/* item.nett_add?.toLocaleString() */}
                    <td className="xl7018834">{formatCurrency(item.nett_add)}</td>
                    <td className="xl7018834">{formatCurrency(item.total_committed_amount)}</td>
                    <td className="xl7018834">{formatCurrency(item.balance_of_contingency)}</td>
                    <td className="xl7018834">{item.time_implication != null && !isNaN(item.time_implication) ? Number(item.time_implication).toFixed(2) : '-'}</td>
                    
                   {/* <td className="xl7018834">
                            <select
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            value={item.star_rate_status}
                            onChange={(e) =>
                                handleEditField(index, 'star_rate_status', e.target.value)
                            }
                            >
                              <option value="" selected>Select Star rate status</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                            </select>
                        </td> */}
                    <td className="xl7018834">
                      <a target="_blank" href={item.rvw_link+"?"+qs_params}>{item.status}</a>
                      {/* <a target="_blank" href={item.rvw_link}>{item.status}</a> */}
                      {/* {item.status} */}
                    </td>
                    <td className="xl7018834">
                      <a target="_blank" href={item.review_link+"&"+qs_params}>{item.review_status}</a>
                      {/* <a target="_blank" href={item.review_link}>{item.review_status}</a> */}
                    </td>
                    {/* <td className="xl7018834">{item.aip_status}</td> */}
                    <td className="xl7018834">{item.soi_no}</td>
                    <td className="xl7018834">{item.issuance_date ? new Date(item.issuance_date).toLocaleDateString() : ''}</td>
                    <td className="xl7018834">{item.supersede_no ? (item.rvw_type +' '+item.supersede_no):''}</td>
                    <td className="xl7018834">{item.star_rate_items}</td>
                    <td className="xl7018834">{item.star_rate_status}</td>
                    {/* <td className="xl7018834" >
                      <a target="_blank" href={item.review_link}>{item.review_link}</a>
                    </td> */}
                    {/* {selectedColumns.includes('rvw_no') && <td className="xl7018834">{item.rvw_no}</td>}
{selectedColumns.includes('submitted_by') && <td className="xl7018834">{item.submitted_by}</td>}
{selectedColumns.includes('rvw_type') && <td className="xl7018834">{item.rvw_type}</td>}
{selectedColumns.includes('rvw_link') && <td className="xl7018834">{item.rvw_link}</td>}
{selectedColumns.includes('description') && <td className="xl7018834">{item.description}</td>}
{selectedColumns.includes('work_description') && <td className="xl7018834">{item.work_description}</td>}
{selectedColumns.includes('reason') && <td className="xl7018834">{item.reason}</td>}
{selectedColumns.includes('nett_add') && <td className="xl7018834">${item.nett_add?.toLocaleString()}</td>}
{selectedColumns.includes('balance_of_contingency') && <td className="xl7018834">${item.balance_of_contingency?.toLocaleString()}</td>}
{selectedColumns.includes('star_rate_items') && <td className="xl7018834">{item.star_rate_items}</td>}
{selectedColumns.includes('star_rate_status') && (
  <td className="xl7018834">
    <select value={item.star_rate_status}  onChange={(e) =>
                                handleEditField(index, 'star_rate_status', e.target.value)
                            }>
      <option value="" selected>Select Start rate status</option>
      <option value="Yes">Yes</option>
      <option value="No">No</option>
    </select>
  </td>
)}
{selectedColumns.includes('status') && <td className="xl7018834">{item.status}</td>}
{selectedColumns.includes('aip_status') && <td className="xl7018834">{item.aip_status}</td>}
{selectedColumns.includes('soi_no') && <td className="xl7018834">{item.soi_no}</td>}
{selectedColumns.includes('issuance_date') && (
  <td className="xl7018834">{item.issuance_date ? new Date(item.issuance_date).toLocaleDateString() : ''}</td>
)}
{selectedColumns.includes('supersede_no') && <td className="xl7018834">{item.supersede_no ? item.supersede_no : ''}</td>}
{selectedColumns.includes('review_status') && <td className="xl7018834">{item.review_status}</td>} */}

                  </tr>
                ))
              ) : (
                <tr>
                  <td className="xl7018834" colSpan="17" style={{ textAlign: 'center' }}>
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default RVMStatus;
